import { useForm } from "react-hook-form";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface LoginForm {
  companyId: string;
  password: string;
}

export default function LoginView() {
  const { register, handleSubmit } = useForm<LoginForm>();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubmit = async (data: LoginForm) => {
    setError(null);

 
    let username = data.companyId.trim();
    if (!username.startsWith("cid-")) {
      username = `cid-${username}`;
    }

    try {
      const res = await fetch(
        "https://staging-third-party-apis.nabil5332.workers.dev/api/v1/auth/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username,
            password: data.password,
          }),
        }
      );

      const json = await res.json();
      console.log(json);

      if (!res.ok || json.success === false) {
        throw new Error(json.error?.message || "Login failed");
      }
      localStorage.setItem("token", json.token);

      navigate("/dashboard/manage");

    } catch (err: any) {
      console.error(err);
      setError(err.message || "Une erreur est survenue");
    }
  };

  return (
    <div
      style={{
        backgroundImage:
          'url("https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1470&q=80")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          backgroundColor: "rgba(113, 66, 145, 0.85)",
          padding: "2rem",
          borderRadius: "1rem",
          color: "white",
          minWidth: "320px",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 0 20px rgba(113,66,145,0.8)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>Connexion</h2>

        <input
          placeholder="Company ID (ex: 123)"
          {...register("companyId")}
          required
          style={{
            width: "100%",
            padding: "0.75rem",
            borderRadius: "0.5rem",
            border: "none",
            boxSizing: "border-box",
            marginBottom: "1rem",
          }}
        />

        <div style={{ position: "relative", marginBottom: "1rem" }}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            {...register("password")}
            required
            style={{
              width: "100%",
              padding: "0.75rem 2.5rem 0.75rem 0.75rem",
              borderRadius: "0.5rem",
              border: "none",
              boxSizing: "border-box",
            }}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "0.75rem",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              userSelect: "none",
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {showPassword ? "🙈" : "👁️"}
          </span>
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "0.75rem",
            borderRadius: "9999px",
            border: "none",
            backgroundColor: "#714291",
            fontWeight: "bold",
            color: "white",
            cursor: "pointer",
          }}
        >
          Login
        </button>

        {error && (
          <p style={{ marginTop: "1rem", color: "yellow", fontSize: "0.9rem" }}>
            ⚠️ {error}
          </p>
        )}
      </form>
    </div>
  );
}
